import { AxiosResponseHeaders } from 'axios';
import {
  ConsolidatedTransactionsPrint,
  ConsolidatedTransactionsPrintResponseDTO,
} from '../../entities/ConsolidatedTransaction/ConsolidatedTransactionsPrintResponseDTO';

const ConsolidatedTransactionsPrintResponseDTOtoTransactionPrintAdapter = (
  response: ConsolidatedTransactionsPrintResponseDTO,
  headers?: AxiosResponseHeaders,
): ConsolidatedTransactionsPrint => {
  if (!response.body) {
    throw Error();
  }

  return {
    report: response.body.report,
  };
};

export { ConsolidatedTransactionsPrintResponseDTOtoTransactionPrintAdapter };
